import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { IsUUID } from 'class-validator';
import { ContractorDto } from '../../contractor/dto/contractor.dto';
import { UserDto } from '../../user/dto/user.dto';
import { JobPhaseContractorHistoryInterface } from '../interfaces/job-phase-contractor-history.interface';
import { JobPhaseDto } from '../../job-phase/dto/job-phase.dto';

@Exclude()
export class JobPhaseContractorHistoryDto
  extends CommonEntityDto
  implements JobPhaseContractorHistoryInterface
{
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Job Phase ID',
  })
  @IsUUID()
  @Expose()
  jobPhaseId!: string;

  @ApiProperty({
    type: 'string',
    nullable: true,
    format: 'uuid',
    title: 'Associated Contractor ID',
  })
  @IsUUID()
  @Expose()
  contractorId!: string;

  @ApiProperty({
    type: 'string',
    nullable: true,
    format: 'uuid',
    title: 'Associated Assigning User ID',
  })
  @IsUUID()
  @Expose()
  assigningUserId!: string;

  @ApiPropertyOptional({
    type: () => JobPhaseDto,
    title: 'Associated Job Phase',
    description:
      'The job phase associated with this job phase contractor history',
  })
  @Expose()
  jobPhase?: JobPhaseDto;

  @ApiPropertyOptional({
    type: () => ContractorDto,
    title: 'Associated Contractor',
    description:
      'The contractor associated with this job phase contractor history',
  })
  @Expose()
  contractor?: ContractorDto;

  @ApiPropertyOptional({
    type: () => UserDto,
    title: 'Associated Assigning User',
    description:
      'The assigning user associated with this job phase contractor history',
  })
  @Expose()
  assigningUser?: UserDto;
}
